<div class="row justify-content-md-center no-gutters greyBgBody text-center marL10" (window:resize)="onResize($event)">
    <app-loader-icon *ngIf="showLoader"></app-loader-icon>
    <div class="col-12">
        <div class="row no-gutters">
            <div class="col-12 manageMailBoxSection whiteBg">
                <div #searchFieldsHeight>
                    <h5 class="sectionTitleBig text-left">
                        Organization Search<span class="searchDrownArrow" *ngIf="seaerchAreaDownArrow"
                            (click)="searchAreaExpand()">
                            <i class="fa fa-chevron-down"></i>
                        </span><span class="searchDrownArrow" *ngIf="seaerchAreaUpArrow" (click)="searchAreaCollapse()">
                            <i class="fa fa-chevron-up"></i>
                        </span>
                    </h5>

                    <form [formGroup]="addClientForm">
                        <div *ngIf="searchAreaFields">
                          <div class="row">
                            <div class="col-4 display_inlineBlock align-section-left">
                              <label for="CompanyName">Company/Organization</label>

                              <div class="form-group">
                                <input class="form-control" type="text" formControlName="CompanyName"
                                       id="CompanyName" (keydown.enter)="onSearch($event)"
                                       [ngClass]="{ 'is-invalid': addClientForm.get('CompanyName').invalid && validForm } "
                                       (focusout)="onFocusOutCompany($event)" (keyup)="onChange($event)" />
                              </div>
                            </div>
                            <div class="col-4 display_inlineBlock align-section-left">
                              <label for="DunsId">DUNS</label>

                              <div class="form-group">
                                <input class="form-control" type="text" id="DunsId" formControlName="DunsId"
                                       (keydown.enter)="onSearch($event)"
                                       [ngClass]="{ 'is-invalid': (addClientForm.get('DunsId').invalid && validForm) }"
                                       (keypress)="acceptAlphanumericInput($event)" (keyup)="onChange($event)" />
                              </div>
                            </div>
                            <div class="col-4 display_inlineBlock align-section-left">
                              <label for="select-accountHierarchy">Account Hierarchy</label>
                              <div class="form-group">
                                <select class="form-control custom-select" id="select-accountHierarchy"
                                        formControlName="AccountHierarchy" (keydown.enter)="onSearch($event)"
                                        (ngModelChange)="onChange($event)"
                                        [ngClass]="{ 'is-invalid': addClientForm.get('AccountHierarchy').invalid && validForm }">
                                  <option [ngValue]="null" hidden disabled selected>
                                    Select
                                  </option>
                                  <option value="Parent">Parent</option>
                                  <option value="Subsidiary">Subsidiary</option>
                                </select>
                                <i class="fa fa-chevron-down"></i>
                              </div>
                            </div>
                          </div>
                            <div class="row">
                               
                                <div class="col-4 display_inlineBlock align-section-left">
                                    <label for="ParentAccountName">Parent Account Name</label>
                                    <div class="form-group">
                                        <input class="form-control" type="text" id="ParentAccountName" 
                                            formControlName="ParentAccountName"
                                            (keydown.enter)="onSearch($event)"
                                            [ngClass]="{ 'is-invalid': addClientForm.get('ParentAccountName').invalid && validForm }"
                                            (keyup)="onChange($event)" />
                                    </div>
                                </div>
                                <div class="col-4 display_inlineBlock align-section-left">
                                    <label for="ParentAccountDUNS">Parent Account DUNS</label>
                                    <div class="form-group">
                                        <input class="form-control" type="text" id="ParentAccountDUNS" 
                                            formControlName="ParentAccountDUNS"
                                            (keydown.enter)="onSearch($event)"
                                            [ngClass]="{ 'is-invalid': addClientForm.get('ParentAccountDUNS').invalid && validForm }"
                                            (keypress)="acceptAlphanumericInput($event)" 
                                            (keyup)="onChange($event)" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4 display_inlineBlock align-section-left">
                                    <div class="row">
                                        <div class="col-12">
                                            <label for="select-industry">Industry</label>
                                            <div class="form-group">
                                                <select class="form-control custom-select" id="select-industry"
                                                    (ngModelChange)="industryChange($event)"
                                                    formControlName="sessionIndustry" (keydown.enter)="onSearch($event)"
                                                    [ngClass]="{ 'is-invalid': addClientForm.get('sessionIndustry').invalid && validForm }">


                                                    <option [ngValue]="null" hidden disabled selected>
                                                        Select
                                                    </option>
                                                    <option *ngFor="let item of dropdownData.Industries"
                                                        [attr.selected]="item.ID==session.industryid?true:null"
                                                        [attr.value]='item.ID'
                                                        [hidden]="item.IsMDR || (!showNAFields && item.ID == 34)">
                                                        {{item.Name}}
                                                    </option>
                                                </select>
                                                <i class="fa fa-chevron-down"></i>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-4 display_inlineBlock align-section-left">
                                    <div class="row">
                                        <div class="col-12">
                                            <label for="select-sector">Sector</label>
                                            <div class="form-group">
                                                <select class="form-control custom-select" id="select-sector"
                                                    formControlName="sessionSector"
                                                    (ngModelChange)="onSectorChange($event)"
                                                    (keydown.enter)="onSearch($event)"
                                                    [ngClass]="{ 'is-invalid': addClientForm.get('sessionSector').invalid && validForm}">


                                                    <option [ngValue]="null" hidden disabled selected>Select</option>
                                                    <option *ngFor="let item of dropdownData_Sectors"
                                                        [attr.selected]="item.SectorID==session.sectorid?true:null"
                                                        [attr.value]='item.SectorID'>
                                                        {{item.SectorName}}
                                                    </option>
                                                </select>
                                                <i class="fa fa-chevron-down"></i>

                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-12 separateLineTop">
                            <div class="col-12 ">
                                <div class="text-right">
                                    <button class="clickBtn mr10" (click)="createOrg()">
                                        Create New Organization
                                    </button>
                                    <button type="button" class="clickBtn mr10"
                                        (click)="onSearch($event)" [disabled]="!enableSearch">
                                        {{isSearchModify ? 'Modify Search' : 'Search' }}
                                    </button>
                                    <button type="button" class="clickBtn" [disabled]="!enableSearch"
                                        (click)="clearSearchData()">
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div id="errorMsg" class="errorMessage">
                            <div class="mandatoryFieldsError" *ngIf="!addClientForm.valid && validForm">
                                Please fill
                                all the mandatory fields (*)
                            </div>

                        </div>
                        <div *ngIf="isShowTable" class="col-12 display_inlineBlock separateLineTop">
                            <div class="manageMailBoxDatGridArea searchDataTable searchOrgDataTable" id="gridScroll"
                                (scroll)="onScroll($event)">

                                <app-smart-data-grid [sampleColumns]="sampleColumns" [sampleData]="filteredClients"
                                    [allowCheckbox]="false" [iseventRegistered]="true" [allowPagination]="false"
                                    [isClientSidePagination]="false" [pageSize]="10" [totalRecord]="totalRecords"
                                    [isInfiniteScroll]="true"></app-smart-data-grid>
                            </div>
                        </div>
                    </form>
                </div>


            </div>

        </div>
    </div>

</div>

<!-- Modal -->
<div class="updateEmail">
    <ng-template #content let-modal>
        <div class="modal-header">
        </div>
        <div class="modal-body">
            <div *ngIf="resultModalContent">
                <p>
                    {{resultModalContent}}
                </p>
            </div>
        </div>
        <div class="modal-footer">
            <button *ngIf="verifyCompanyRes == 1 || verifyCompanyRes == 3" type="button" class="clickBtn"
                data-bs-dismiss="modal" (click)="clearData();modal.dismiss('Cross click')">
                OK
            </button>
            <button *ngIf="verifyCompanyRes == 2" type="button" class="clickBtn" data-bs-dismiss="modal"
                (click)="onSubmitAddCompany('UPDATE',createFormValues);modal.dismiss('Cross click')">
                Yes
            </button>
            <button *ngIf="verifyCompanyRes == 2" type="button" class="clickBtn" data-bs-dismiss="modal"
                (click)="clearData();modal.dismiss('Cross click')">
                Cancel
            </button>
        </div>
    </ng-template>
</div>
